<template>
  <v-app id="inspire">
    <v-fade-transition mode="out-in">
      <component :is="layout">
        <v-scroll-x-transition mode="out-in">
          <router-view></router-view>
        </v-scroll-x-transition>
      </component>
    </v-fade-transition>
  </v-app>
</template>

<script>
import layouts from '@/layouts'

export default {
  name: 'App',
  components: {
    ...layouts
  },
  computed: {
    layout() {
      let layout = this.$route.matched[0]
        ? this.$route.matched[0].meta.layout || 'default'
        : 'default'

      return `${layout}-layout`
    }
  }
}
</script>

<style src="@/assets/css/custom.css"></style>
